'use strict';
const minTime = 8;
const maxTime = 20;
var activeModal = null;

function showCurrentModal(modalName, callback) {
    event.preventDefault();
    if (activeModal) {
        activeModal.style.display = 'none';
    }
    try {
        var currentModal = document.getElementById(modalName);
        activeModal = currentModal;
        currentModal.style.display = 'block';
        if (callback) {
            callback();
        }
    } catch (e) {
        console.warn(e);
    }
}

function getCallBack(s) {
    event.preventDefault();
    if (typeof s === 'undefined') { s = ''; }
    var form = event.target;

    var callFromStr = '';
    var callToStr = '';
    if (document.getElementById('commonSelect' + s) !== null) { // it exists!
        callFromStr = document.getElementById('commonSelect' + s).querySelector('#startTime'+s+'-styler .jq-selectbox__select .jq-selectbox__select-text').textContent;
        callToStr = document.getElementById('commonSelect' + s).querySelector('#endTime'+s+'-styler .jq-selectbox__select .jq-selectbox__select-text').textContent;
    } else { callFromStr = minTime; callToStr = maxTime; }

    var postData = {
        Profiles: {
            name: form.elements.name.value,
            phone: form.elements.phone.value
        },
        callFrom: callFromStr,
        callTo: callToStr
    };

    fetch('/callback/order-callback', {
        method: 'post',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Content-type': 'application/json'
        },
        body: JSON.stringify(postData)
    }).then(function (response) {
        return response.json();
    }).then(function (data) {
        if (data.errors.length === 0) {
            document.getElementById('feedback').style.display = 'none';
            document.querySelector('.answer-request').style.display = 'block';
            activeModal = document.querySelector('.answer-request');
            $('#modal').modal('show');
            $('.phone_field_msg').css("display", "none");
        } else {
            $('.phone-mask').css("border", "1px solid red");
            $('.phone_field_msg').html("<p style='color: red;padding-top: 3px;'>Введите корректный номер</p>");
            $('.phone_field_msg').css("display", "block");
            
        }
    }).catch(function (error) {
        console.log('Request failed', error);
    });
}

/**
 * Предзагрузка выпадающих списков со временем заказа обратного звонка (в зависимости от текущего времени)
 * В мобильной версии выпадающие списки не видны, передается весь диапазон
 */
function preloadCallBack(s) {

    if (typeof s === 'undefined') { s = ''; }

    var startTimeEl = document.getElementById('startTime' + s);
    var endTimeEl = document.getElementById('endTime' + s);
    var commonSelectEl = document.getElementById('commonSelect' + s);

    const selectStart = startTimeEl.cloneNode(false);
    const selectEnd = endTimeEl.cloneNode(false);

    startTimeEl.parentElement.remove();
    endTimeEl.parentElement.remove();
    commonSelectEl.insertBefore(selectStart, document.getElementById('beforeSelectEnd' + s));
    commonSelectEl.appendChild(selectEnd);

    var date = new Date();
    var currentDate = new Date(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours() + 3);
    var currentDay = currentDate.getDay();
    var currentHour = currentDate.getHours();
    var startTime = 8;

    if (currentHour >= minTime && currentHour < maxTime) {
        startTime = currentHour;
    }

    var optionsForStart = '<option class="selected">' + startTime + '</option>';
    var optionsForEnd = '<option class="selected">' + (startTime + 1) + '</option>';

    for (var i = startTime + 1, j = startTime + 2; i < maxTime; i++, j++) {
        optionsForStart += '<option>' + i + '</option>';
        optionsForEnd += '<option>' + j + '</option>';
    }

    selectStart.insertAdjacentHTML('afterBegin', optionsForStart);
    selectEnd.insertAdjacentHTML('afterBegin', optionsForEnd);
    initialSelect();
}

function changeStartTime(s) {

    if (typeof s === 'undefined') { s = ''; }

    const selectEnd = document.getElementById('endTime' + s).cloneNode(false);
    document.getElementById('endTime' + s).parentElement.remove();
    document.getElementById('commonSelect' + s).appendChild(selectEnd);

    var startTime = Number(document.getElementById('startTime' + s).value);
    var optionsForEnd = '<option class="selected">' + (startTime + 1) + '</option>';

    for (var j = startTime + 1; j <= maxTime; j++) {
        optionsForEnd += '<option>' + j + '</option>';
    }

    selectEnd.insertAdjacentHTML('afterBegin', optionsForEnd);
    initialSelect();
}

function initialSelect() {
    $('.input-select').styler({
        selectSmartPositioning: false
    });
}


try {
    // Закомментировано в modal.twig
    /*
    if (location.pathname === '/' && App.cookie.get('PSID') && document.getElementById('unlogin').style.display === 'block') {
        document.getElementById('unlogin').style.display = 'none';
        document.getElementById('logined').style.display = 'block';
    }
    */
    if (location.pathname == '/contacts') {
        preloadCallBack('1');
    }
} catch (e) {
    console.log(e);
}

